<template>
  <app-card
    v-if="displayed"
    v-intersect="{
      handler: (entry) => entry && registerImpressionAnalytics(),
      options: { threshold: 0.7 }
    }"
  >
    <v-card-text>
      <div class="d-flex justify-space-between align-center mb-4 mr-6">
        <div class="font-weight-bold font-size-big">
          {{ $translate("DesktopInviteBanner.invitePeopleToJoin", { communityName: configuration.artistLongName }) }}
        </div>
        <the-button icon small class="corner-button color-post-detail" custom-colors @click="setDesktopInviteBannerSkipDate">
          <i-custom-close class="size-3" />
        </the-button>
      </div>

      <invite-members-button :analytics-key="analyticsKey" button-secondary @open="registerOpenInviteButtonEvent" />
    </v-card-text>
  </app-card>
</template>

<script>
import { mapState, mapActions } from "pinia"

import { useAppStateStore } from "@/store/appState.js"
import { useConfigurationStore } from "@/store/configuration.js"

import { parseISO, differenceInWeeks } from "date-fns"
import { registerAnalyticsEvent } from "@/services/analytics.js"

import InviteMembersButton from "@/components/InviteMembersButton.vue"
import * as texts from "@/services/texts.js"

export default {
  components: {
    InviteMembersButton
  },
  data() {
    return {
      analyticsKey: texts.generateUUID()
    }
  },
  computed: {
    ...mapState(useConfigurationStore, ["configuration"]),
    ...mapState(useAppStateStore, ["desktopInviteBannerSkipDate"]),
    displayed() {
      return !this.desktopInviteBannerSkipDate || differenceInWeeks(new Date(), parseISO(this.desktopInviteBannerSkipDate)) >= 2
    }
  },
  methods: {
    ...mapActions(useAppStateStore, ["setDesktopInviteBannerSkipDate"]),
    registerImpressionAnalytics() {
      registerAnalyticsEvent({
        name: "invite-link-banner-impression"
      })
    },
    registerOpenInviteButtonEvent() {
      registerAnalyticsEvent({
        name: "invite-link-banner-open",
        attributes: { key: this.analyticsKey }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.corner-button {
  position: absolute !important;
  top: 8px;
  right: 8px;
}
</style>
